<template>
	<div class="launch-card">
		<div class="content">
			<span class="name">No Results!</span>
		</div>
	</div>
</template>
<script>
export default {
	name: "NoResults"
};
</script>
<style src="../styles/style.css">
.name {
	font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/NoResults.vue